import { css } from 'styled-components'

import { Container } from '../../styles/defaults'

export const MiniContainer = Container.extend`
  width: 1000px;
  margin-top: 6rem;
  ${props =>
    props.sm &&
    css`
      margin-top: 3rem;
  `};
`



// WEBPACK FOOTER //
// ./src/views/FAQ/styles.js